export default {
    items: [
        {
            name: 'Dashboard',
            url: '/dashboard',
            icon: 'fa fa-dashboard',
            groups: ['PGEPROAJU-ADMINISTRADOR', 'PGEPROAJU-DIVIDAATIVA']
        },
        {
            name: 'Acompanhamento do Protesto',
            url: '/acompanhamento-protesto',
            icon: 'fa fa-dashboard',
            groups: ['PGEPROAJU-ADMINISTRADOR', 'PGEPROAJU-DIVIDAATIVA']
        },
        {
            name: 'Cartas Para Assinar e Emissão em Lote',
            url: '/assinar-cartas-lote',
            icon: 'fa fa-certificate',
            groups: ['PGEPROAJU-ADMINISTRADOR', 'PGEPROAJU-DIVIDAATIVA']
        },
        {
            name: 'Cartas Emitidas e Emissão Individual',
            url: '/emitir-cartas',
            icon: 'fa fa-envelope-o',
            groups: ['PGEPROAJU-ADMINISTRADOR', 'PGEPROAJU-DIVIDAATIVA']
        },
        {
            name: 'Agenda de Prazos',
            url: '/agenda',
            icon: 'fa fa-calendar',
            groups: ['PGEPROAJU-ADMINISTRADOR', 'PGEPROAJU-AGENDAPRAZO-PROC', 'PGEPROAJU-AGENDAPRAZO-ASSES']
        },
        {
            name: "Pesquisa",
            url: '/consultar-cdas',
            icon: 'fa fa-search',
            groups: ['PGEPROAJU-ADMINISTRADOR', 'PGEPROAJU-DIVIDAATIVA', 'PGEPROAJU-CONSULTA', 'PGEPROAJU-CONSULTAEDITAEF', 'PGEPROAJU-AGENDAPRAZO-PROC', 'PGEPROAJU-AGENDAPRAZO-ASSES']
        },
        {
            name: 'Configurações',
            url: '#',
            icon: 'fa fa-keyboard-o',
            groups: ['PGEPROAJU-ADMINISTRADOR', 'PGEPROAJU-DIVIDAATIVA', 'PGEPROAJU-CONSULTAEDITAEF'],
            children: [
                {
                    name: 'Modelo',
                    url: '/minuta',
                    icon: 'fa fa-eye',
                    groups: ['PGEPROAJU-ADMINISTRADOR']
                },
                {
                    name: 'Feriado',
                    url: '/crud/feriado',
                    icon: 'fa fa-calendar',
                    groups: ['PGEPROAJU-ADMINISTRADOR']
                },
                {
                    name: 'Palavra-chave',
                    url: '/crud/palavra-chave',
                    icon: 'fa fa-paragraph',
                    groups: ['PGEPROAJU-ADMINISTRADOR']
                },
                {
                    name: 'Grupo de Trabalho',
                    url: '/crud/grupo-trabalho',
                    icon: 'fa fa-users',
                    groups: ['PGEPROAJU-ADMINISTRADOR']
                },
                {
                    name: 'UPF/PR',
                    url: '/atualizar-upf-pr',
                    icon: 'fa fa-dollar',
                    groups: ['PGEPROAJU-ADMINISTRADOR']
                },
                {
                    name: 'Exceções',
                    url: '/excecoes',
                    icon: 'fa fa-exclamation',
                    groups: ['PGEPROAJU-ADMINISTRADOR', 'PGEPROAJU-DIVIDAATIVA']
                },
                {
                    name: 'Tabelionato',
                    url: '/tabelionato',
                    icon: 'fa fa-bank',
                    groups: ['PGEPROAJU-ADMINISTRADOR']
                },
                {
                    name: 'Comarca',
                    url: '/comarca',
                    icon: 'fa fa-arrows',
                    groups: ['PGEPROAJU-ADMINISTRADOR']
                },
                {
                    name: 'Réu Federal',
                    url: '/reu-federal',
                    icon: 'fa fa-user-circle-o',
                    groups: ['PGEPROAJU-ADMINISTRADOR']
                },
                {
                    name: 'Usuário',
                    url: '/usuario',
                    icon: 'fa fa-group',
                    groups: ['PGEPROAJU-ADMINISTRADOR']
                },
                {
                    name: 'Procurador',
                    url: '/procurador',
                    icon: 'fa fa-black-tie',
                    groups: ['PGEPROAJU-ADMINISTRADOR']
                },
                {
                    name: 'Juízo',
                    url: '/juizo',
                    icon: 'fa fa-gavel',
                    groups: ['PGEPROAJU-ADMINISTRADOR']
                },
                {
                    name: 'Petição',
                    url: '/peticao',
                    icon: 'fa fa-file-powerpoint-o',
                    groups: ['PGEPROAJU-ADMINISTRADOR']
                },
                {
                    name: 'Parâmetros do Sistema',
                    url: '/parametros-sistema',
                    icon: 'fa fa-cogs',
                    groups: ['PGEPROAJU-ADMINISTRADOR']
                },
                {
                    name: 'Parâmetros GR',
                    url: '/parametros-gr',
                    icon: 'fa fa-cogs',
                    groups: ['PGEPROAJU-ADMINISTRADOR']
                },
                {
                    name: 'Limite Protestos',
                    url: '/limiteProtestos',
                    icon: 'fa fa-arrows',
                    groups: ['PGEPROAJU-ADMINISTRADOR']
                },
                {
                    name: "Processamento Arquivos Pagamento",
                    url: '/processamento-arquivos',
                    icon: 'fa fa-stack-overflow',
                    groups: ['PGEPROAJU-ADMINISTRADOR']
                },
                {
                    name: "Migração e Edição de EF",
                    url: '/migracao',
                    icon: 'fa fa-share-square-o',
                    groups: ['PGEPROAJU-ADMINISTRADOR', 'PGEPROAJU-CONSULTAEDITAEF']
                },
                {
                    name: 'Tipo de Crédito/Assunto',
                    url: '/tipo-credito-assunto',
                    icon: 'fa fa-share-alt-square',
                    groups: ['PGEPROAJU-ADMINISTRADOR']
                }
            ]
        },
        {
            name: 'Consultas',
            url: '#',
            icon: 'fa fa-search-plus',
            groups: ['PGEPROAJU-RECEITAFEDERAL', 'PGEPROAJU-EPAF'],
            children: [
                {
                    name: 'Receita Federal',
                    url: '/consulta-receita-federal',
                    icon: 'icone-receita',
                    groups: ['PGEPROAJU-RECEITAFEDERAL']
                },
                {
                    name: 'ePAF',
                    url: '/consulta-epaf',
                    icon: 'icone-receita-estadual',
                    groups: ['PGEPROAJU-EPAF']
                }
            ]
        },
        {
            name: 'Relatório Protesto-Ajuizamento',
            url: '/relatorio-protesto-ajuizamento',
            icon: 'fa fa-pie-chart',
            groups: ['PGEPROAJU-ADMINISTRADOR', 'PGEPROAJU-DIVIDAATIVA', 'PGEPROAJU-RELATORIO']
        },
        {
            name: 'Importar Processos Digitalizados',
            url: '/importar-processos-digitalizados',
            icon: 'fa fa-cogs',
            groups: ['PGEPROAJU-ADMINISTRADOR']
        }
    ]
}
